export default __webpack_public_path__ + "static/media/back.3268e998.jpg";